import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../Url";
import { ForgotPasswordActionTypes } from "./ActionTypes";
import { forgotPasswordBody, forgotPasswordValue } from "./Model";
import {
  ForgotPasswordAPIResClearAction,
  ForgotPasswordErrorAction,
  ForgotPasswordLoadingAction,
  ForgotPasswordSuccessAction,
  ForgotPasswordUpdateAPIMsgAction,
} from "./Actions";
import { ApiHeader } from "../../components/Utility";
import { setupInterceptorsTo } from "../Authentication/Interceptors";

let apiRes = {} as forgotPasswordValue;
export const forgotPasswordApi = (email: forgotPasswordBody) => {

  return function (dispatch: Dispatch<ForgotPasswordActionTypes>) {
    dispatch(ForgotPasswordLoadingAction(true));
    setupInterceptorsTo(axios)
      .get(baseUrl.baseUrl + `/profileapp/forgot-password/${email.email}/`, {
        headers: ApiHeader,
      })
      .then((res) => {
        apiRes = res.data;
        dispatch(ForgotPasswordLoadingAction(false));
        dispatch(
          ForgotPasswordSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "change password successfully"
          )
        );
      })
      .catch((error) => {
        dispatch(ForgotPasswordLoadingAction(false));
        dispatch(
          ForgotPasswordErrorAction(
            {} as forgotPasswordValue,
            error.response !== undefined
              ? error.response.data.message || error.response.data.detail
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const updateForgotPasswordAPIResMsg = () => {
  return function (dispatch: Dispatch<ForgotPasswordActionTypes>) {
    dispatch(
      ForgotPasswordUpdateAPIMsgAction(apiRes as forgotPasswordValue, "", "", 0)
    );
  };
};

export const clearForgotPasswordAPIRes = () => {
  return function (dispatch: Dispatch<ForgotPasswordActionTypes>) {
    dispatch(ForgotPasswordAPIResClearAction({} as forgotPasswordValue, "", "", 0));
  };
};

